module.exports = __webpack_public_path__ + "img/subscribe1.88f1236e.png";